import { useState } from "react";
import cx from "classnames";

import CircleCheckMarkIcon from "components/Icons/circle_check_mark.svg";
import InfoIcon from "components/Icons/info.svg";
import ClearIcon from "components/Icons/x.svg";

const sizes = ["small", "large"] as const;
const icons = ["warn", "check"] as const;

const iconSizes: Record<(typeof sizes)[number], [number, number]> =
  Object.freeze({
    large: [24, 24],
    small: [16, 16],
  });

type Props = {
  className?: string;
  dismissable?: boolean;
  icon?: (typeof icons)[number];
  isFilled?: boolean;
  message: string;
  size?: (typeof sizes)[number];
};

const BagMessage = ({
  className,
  dismissable = false,
  icon = "warn",
  isFilled,
  message,
  size = "large",
}: Props) => {
  const notificationClassName = cx(
    "flex items-center z-10 rounded px-md bg-white",
    className,
    {
      "border bg-yellow-20 border-yellow-60": isFilled,
      "py-lg text-default": size === "large",
      "py-sm text-xs": size === "small",
    },
  );

  const iconClassName = cx("flex flex-shrink-0", {
    "text-green": icon === "check",
    "text-yellow": icon === "warn",
  });

  const [width, height] = iconSizes[size];
  const [showNotification, setShowNotification] = useState(true);
  const onCloseClick = () => setShowNotification(false);

  if (!showNotification) {
    return null;
  }

  return (
    <>
      <style jsx>{`
        .toast {
          position: absolute;
          top: 30px;
          right: 15px;
          left: 15px;
        }
        @media (min-width: 768px) {
          .toast {
            position: absolute;
            top: 30px;
            right: 0px;
            left: 0px;
          }
        }
      `}</style>
      <div className={notificationClassName}>
        {icon === "check" ? (
          <CircleCheckMarkIcon
            height={height}
            width={width}
            className={iconClassName}
          />
        ) : (
          <InfoIcon height={height} width={width} className={iconClassName} />
        )}
        <div className="ml-md mr-md flex-grow">{message}</div>
        {dismissable && (
          <button aria-label="close message" onClick={onCloseClick}>
            <ClearIcon height="16" width="16" className="flex flex-shrink-0" />
          </button>
        )}
      </div>
    </>
  );
};

export default BagMessage;
